import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { getPropertiesBySellerId } from '../../Redux/Actions/actions';
import style from './AnotarVisita.module.css';

const AnotarVisita = () => {
  const dispatch = useDispatch();
  const userId = useSelector(state => state.userId);
  const properties = useSelector(state => state.propertiesBySellerId);

  useEffect(() => {
    if (userId) {
      dispatch(getPropertiesBySellerId(userId));
    }
  }, [userId, dispatch]);

  const formatPrice = (price) => {
    if (!price) return '0';
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  return (
    <div className={style.container}>
      <div className={style.header}>
        <h2 className={style.title}>Anotar Visita</h2>
        <Link to="/visita-externa/nueva" className={style.externalButton}>
          + Visita Externa
        </Link>
      </div>

      <p className={style.subtitle}>Seleccioná una propiedad para anotar la visita</p>

      {!userId && (
        <div className={style.emptyState}>
          No se encontró el ID del usuario. Por favor, iniciá sesión nuevamente.
        </div>
      )}

      {userId && properties.length === 0 && (
        <div className={style.emptyState}>
          No tenés propiedades activas en este momento.
        </div>
      )}

      <div className={style.grid}>
        {properties.map((property) => (
          <Link
            key={property.id}
            to={`/visita/${property.id}`}
            className={style.card}
          >
            <div className={style.imageContainer}>
              {property?.photo?.length > 0 ? (
                <img
                  src={property.photo[0]}
                  className={style.image}
                  alt={property.title}
                />
              ) : (
                <div className={style.noImage}>Sin imagen</div>
              )}
            </div>
            <div className={style.cardContent}>
              <h3 className={style.cardTitle}>{property.title}</h3>
              <p className={style.cardPrice}>
                {property.currency} ${formatPrice(property.price)}
              </p>
              {(property.street || property.locality) && (
                <p className={style.cardLocation}>
                  {[
                    [property.street, property.number].filter(Boolean).join(' '),
                    property.locality,
                    property.province,
                    property.country
                  ].filter(Boolean).join(', ')}
                </p>
              )}
              <span className={style.cardAction}>Anotar visita →</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AnotarVisita;
